import React, {Component, Fragment} from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CustomLoader from "../common/CustomLoader";
import StreamPage from "./StreamWebPage";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import PlayCircleFilledIcon from "@material-ui/core/SvgIcon/SvgIcon";

class MainPage extends Component {
    constructor(props) {
        super(props);
    };

    state = {
        isRequested: true,
        agentList: [],
        selectedDevice: null,
        iceServers: {},
    };

    GetAgentList = () => {
        const access_info = JSON.parse(sessionStorage.getItem('access_info'));
        let accessToken = '';
        if (access_info) {
            accessToken = access_info.access_token;
        }

        this.setState({
            isRequested: true,
        });
        fetch('/api/', {
            method: 'post',
            headers: {'Content-type': 'application/json'},
            body: JSON.stringify({
                data: {
                    category: 'private',
                    service: 'GetAgentList',
                    access_token: accessToken,
                }
            })
        }).then(res => {
            if (res) {
                return res.json();
            }
        }).then(json => {
            if (!json) {
                return;
            }
            let agentList = [];
            if (json.data && json.data.agent_list) {
                agentList = json.data.agent_list
            }
            this.setState({
                isRequested: false,
                agentList: agentList,
            });
        }).catch(err => {
            console.log(err);
        });
    };

    GetSystemInformation = () => {
        const access_info = JSON.parse(sessionStorage.getItem('access_info'));
        let accessToken = '';
        if (access_info) {
            accessToken = access_info.access_token;
        }
        let send_data = {
            category: 'private',
            service: 'GetSystemInformation',
            access_token: accessToken,
        };

        fetch('/api/', {
            method: 'post',
            headers: {'Content-type': 'application/json'},
            body: JSON.stringify({
                "data": send_data
            })
        })
            .then(res => {
                console.log('service', res);
                if (res) {
                    return res.json();
                }
            })
            .then(json => {
                if (!json) {
                    return;
                }
                if (json.err) {
                    console.log('service 실패', send_data.service, json);
                } else {
                    console.log('service 성공', send_data.service, json);
                    this.setState({
                        iceServers: {
                            iceServers: json.data.ice_servers
                        },
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
    };
    handleClickedListItem = (e, value) => {
        e.preventDefault();
        console.log('value:', value)
        this.setState({
            selectedDevice: value,
        })
    };
    clearSelectedDevice = () => {
        this.setState({
            selectedDevice: null,
        })
    };

    componentWillMount() {
        this.GetSystemInformation()
    }
    componentDidMount() {
        const {GetAgentList} = this;
        GetAgentList();
    }

    render() {
        const {isRequested, selectedDevice} = this.state;
        const {handleClickedListItem, clearSelectedDevice} = this;

        return (
            <Fragment>
                {isRequested ?
                    <CustomLoader/>
                    : (selectedDevice ?
                        <StreamPage
                            device={selectedDevice}
                            clearSelectedDevice={clearSelectedDevice}
                            iceServers={this.state.iceServers}
                        />
                        : <div className={'App-agent-list'}>
                            <AppBar position="static"
                                    style={{ background: '#000000' }}>
                                <Toolbar variant="dense"
                                >
                                    <Typography variant="h6" color="inherit">
                                        My Computers
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <List>
                                {
                                    this.state.agentList.sort(function (a, b) {
                                        if ( a.name < b.name ){
                                            return -1;
                                        }
                                        if ( a.name > b.name ){
                                            return 1;
                                        }
                                        return 0;
                                    }).map(value => {
                                        return (<ListItem key={value.device_access_token}>
                                            <ListItemText
                                                className={'agent-list-item'}
                                                primary={value.name}
                                                onClick={(e) => {
                                                    handleClickedListItem(e, value)
                                                }}
                                            />
                                        </ListItem>);
                                    })
                                }
                            </List>
                        </div>)

                }
            </Fragment>
        )
    }

}

export default MainPage;